import { render } from "./ordersVue.vue?vue&type=template&id=4e2b28b5"
import script from "./ordersVue.vue?vue&type=script&lang=js"
export * from "./ordersVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__